import _ from 'underscore';
import { useContext, useMemo } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

export const useSetupInstrument = (scenarioName, activityName) => {
  const instrumentation = useContext(InstrumentationContext);

  const backupLogger = useMemo(() => ({
    trace: _.noop,
    error: _.noop,
  }), []);

  return useMemo(() => {
    if (instrumentation && instrumentation[scenarioName]) {
      const scenario = instrumentation[scenarioName].create();
      if (scenario[activityName]) {
        return scenario[activityName].create();
      }
    }
    return backupLogger;
  }, [activityName, backupLogger, instrumentation, scenarioName]);
};
